<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="downloadDocumento()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        }
    },

    methods: {
        downloadDocumento() {
            this.$store.dispatch('addRequest')
            let documentoDto = {
                documentoContratoId: this.documento.documentoContratoId,
                idContrato: this.$route.params.contratoId
            }
            this.dataServicos.obterDocumento(documentoDto).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do anexo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.documento.nomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
